const DEFAULT_SITE_NAME = 'Presentear.Net';
const DEFAULT_SITE_URL = 'https://presentear.net';

/**
 * True quando o app roda em ambiente local (dev no PC ou acesso pelo celular
 * via IP da rede).
 */
export const isLocalEnvironment = (): boolean => {
  if (typeof window === 'undefined') return false;
  const hostname = window.location.hostname;
  return (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname === '0.0.0.0' ||
    hostname === '::1' ||
    hostname.endsWith('.local') ||
    /^192\.168\./.test(hostname) ||
    /^10\./.test(hostname) ||
    /^172\.(1[6-9]|2\d|3[01])\./.test(hostname)
  );
};

/**
 * True quando o app roda no ambiente de staging (stage.<dominio>). O stage
 * usa dados reais mas NÃO deve poluir as métricas de produção.
 */
export const isStagingEnvironment = (): boolean => {
  if (typeof window === 'undefined') return false;
  return window.location.hostname.startsWith('stage.');
};

/**
 * Portão único usado para NÃO disparar tags de marketing/analytics
 * (GA, Google Ads, Meta Pixel, Microsoft UET) fora de produção — ou seja,
 * em ambiente local e em staging.
 */
export const shouldDisableTracking = (): boolean =>
  isLocalEnvironment() || isStagingEnvironment();

export const getSiteName = () => process.env.REACT_APP_SITE_NAME || DEFAULT_SITE_NAME;

export const getSiteUrl = () =>
  (process.env.REACT_APP_SITE_URL || DEFAULT_SITE_URL).replace(/\/$/, '');

export const getSiteHost = () => getSiteUrl().replace(/^https?:\/\//i, '');

export const getContactEmail = () => `contato@${getSiteHost()}`;

export const formatTitle = (pageTitle: string) => `${getSiteName()} - ${pageTitle}`;
